import { r as B, c as S, h as r, H as E, g as D, o as j } from "./main-bb89b2f2.js";
import { s as a } from "./option-b48f45a6-1c465473.js";
import { s as W } from "./synteticHtmlElementId-48c58699-07e8ae8e.js";
import { T as s } from "./translation-service-06f7c8c7-b6396601.js";
import "vue";
const p = "Wähle eine Option", T = {
  inputAriaLabel: p
}, F = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: p,
  default: T
}), u = "Select an option", J = {
  inputAriaLabel: u
}, P = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: u,
  default: J
}), c = "Selecciona una opción", $ = {
  inputAriaLabel: c
}, K = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: c,
  default: $
}), h = "Sélectionnez une option", U = {
  inputAriaLabel: h
}, V = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: h,
  default: U
}), b = "Seleziona un'opzione", q = {
  inputAriaLabel: b
}, H = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: b,
  default: q
}), f = "オプションを選択", N = {
  inputAriaLabel: f
}, R = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: f,
  default: N
}), v = "옵션 선택", G = {
  inputAriaLabel: v
}, M = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: v,
  default: G
}), y = "Selecteer een optie", Q = {
  inputAriaLabel: y
}, X = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: y,
  default: Q
}), w = "Wybierz opcję", Y = {
  inputAriaLabel: w
}, Z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: w,
  default: Y
}), m = "Selecione uma opção", ee = {
  inputAriaLabel: m
}, te = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: m,
  default: ee
}), g = "Выберите вариант", oe = {
  inputAriaLabel: g
}, ne = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: g,
  default: oe
}), x = "Bir seçenek seçin", re = {
  inputAriaLabel: x
}, ie = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: x,
  default: re
}), I = "选择一个选项", le = {
  inputAriaLabel: I
}, ae = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  inputAriaLabel: I,
  default: le
}), se = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.pointer-events-none{pointer-events:none}.relative{position:relative}.top-\\[1px\\]{top:1px}.z-\\[1\\]{z-index:1}.z-\\[2\\]{z-index:2}.box-border{box-sizing:border-box}.flex{display:flex}.contents{display:contents}.hidden{display:none}.max-h-\\[240px\\]{max-height:240px}.w-full{width:100%}.cursor-pointer{cursor:pointer}.justify-start{justify-content:flex-start}.overflow-auto{overflow:auto}.overflow-x-hidden{overflow-x:hidden}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.rounded-none{border-radius:0}.border{border-width:1px}.border-0{border-width:0}.p-0{padding:var(--spacing-0)}.px-\\[10px\\]{padding-left:10px;padding-right:10px}.font-text{font-family:var(--copytext-font-family)}.text-copy{font-size:var(--copytext-font-size)}.outline-none{outline:2px solid transparent;outline-offset:2px}.outline{outline-style:solid}:host{display:contents}.dropdown{-webkit-user-select:none;-moz-user-select:none;user-select:none}.dropdown .overlayButton{background-color:transparent;border:none;border-radius:0;box-sizing:border-box;color:var(--dropdown-text-subtle-default);cursor:pointer;font-family:var(--copytext-font-family);font-size:var(--copytext-font-size);height:var(--component-default-size);line-height:20px;outline:none;z-index:1}.dropdown .overlayButton.small{font-size:var(--copytext-font-size-small);height:40px}.dropdown .overlayButton.small input{height:30px}.dropdown .overlayButton.big{height:48px}.dropdown .overlayButton.big input{font-size:var(--copytext-font-size);height:38px}.dropdown .overlayButton .overlayInputWrapper .overlayArrowIcon{position:relative;top:1px}.dropdown .overlayButton .overlayInputWrapper .overlayArrowIcon *{fill:var(--dropdown-text-subtle-default)}.dropdown .overlayButton .overlayInputWrapper .overlayInput{caret-color:transparent;color:var(--dropdown-text-subtle-filled);overflow:hidden;pointer-events:none;text-overflow:ellipsis;white-space:nowrap}.dropdown .overlayButton .overlayInputWrapper input{background:inherit;border-width:0;box-sizing:border-box;cursor:pointer;font-family:var(--copytext-font-family);outline:2px solid transparent;outline-offset:2px;padding:var(--spacing-0);width:100%}.dropdown .overlayButton .overlayInputWrapper input::-moz-placeholder{color:var(--dropdown-text-subtle-default)}.dropdown .overlayButton .overlayInputWrapper input::placeholder{color:var(--dropdown-text-subtle-default)}.dropdown .overlayButtonFocused{color:var(--dropdown-text-subtle-focus)!important;z-index:2}.dropdown .overlayButtonDisabled{background-color:var(--dropdown-surface-default);border:none;border-radius:0;box-sizing:border-box;color:var(--dropdown-text-subtle-default);font-family:var(--copytext-font-family);font-size:var(--copytext-font-size);height:var(--component-default-size);line-height:20px;outline:none;pointer-events:none;z-index:1}.dropdown .overlayButtonDisabled *{fill:var(--dropdown-text-disabled);color:var(--dropdown-text-disabled)}.dropdown .overlayButtonDisabled.small{height:40px}.dropdown .overlayButtonDisabled.small input{height:30px}.dropdown .overlayButtonDisabled.big{height:48px}.dropdown .overlayButtonDisabled.big input{height:38px}.dropdown .overlayButtonDisabled .overlayArrowIcon{position:relative;top:1px}.dropdown .overlayButtonDisabled .overlayInputWrapper .overlayInput{color:var(--dropdown-text-subtle-disabled);overflow:hidden;pointer-events:none;text-overflow:ellipsis;white-space:nowrap}.dropdown .overlayButtonDisabled .overlayInputWrapper input{background:inherit;border-width:0;box-sizing:border-box;cursor:pointer;font-family:var(--copytext-font-family);outline:2px solid transparent;outline-offset:2px;padding:var(--spacing-0);pointer-events:none;width:100%}.dropdown .overlayButtonDisabled .overlayInputWrapper input::-moz-placeholder{color:var(--dropdown-text-subtle-disabled);font-size:var(--form-size-placeholder-text)}.dropdown .overlayButtonDisabled .overlayInputWrapper input::placeholder{color:var(--dropdown-text-subtle-disabled);font-size:var(--form-size-placeholder-text)}.dropdown .overlayButtonDisabled:focus{outline:2px solid transparent;outline-offset:2px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.dropdown .overlayItemsContainer{font-family:var(--copytext-font-family);font-size:var(--copytext-font-size-noctx);line-height:var(--copytext-line-height-noctx);max-height:240px;overflow:auto;overflow-x:hidden;overflow:hidden auto}.dropdown .overlayItemsContainer.small{font-size:var(--copytext-font-size-small-noctx);line-height:var(--copytext-line-height-small-noctx)}.dropdown .overlayItemsContainer .dropdown-item{align-items:center;display:flex;justify-content:flex-start;padding-left:10px;padding-right:10px}.dropdown .overlayItemsContainer .dropdown-item-arrow-on-focus{background-color:var(--dropdown-surface-items-hover)}.dropdown .overlayItemsContainer::-webkit-scrollbar{width:8px}.dropdown .overlayItemsContainer::-webkit-scrollbar-button{display:none}.dropdown .overlayItemsContainer::-webkit-scrollbar-thumb{background-color:var(--scrollbar-surface-thumb);border-radius:0}.dropdown .overlayItemsContainer::-webkit-scrollbar-thumb:hover{background-color:var(--scrollbar-surface-thumb-hovered)}.dropdown .overlayItemsContainer::-webkit-scrollbar-track{background-color:var(--scrollbar-surface-track);border:none}@media (hover:hover){.dropdown .overlayButton .overlayInputWrapper:hover{fill:var(--dropdown-text-subtle-hover);color:var(--dropdown-text-subtle-hover)}.dropdown .overlayButton .overlayInputWrapper:hover input::-moz-placeholder{color:var(--dropdown-text-subtle-hover)}.dropdown .overlayButton .overlayInputWrapper:hover input::placeholder{color:var(--dropdown-text-subtle-hover)}.dropdown .overlayItemsContainer .dropdown-item:hover:not(.no-hover){background-color:var(--dropdown-surface-items-hover)}}.static{position:static}.inline-block{display:inline-block}.items-center{align-items:center}.justify-between{justify-content:space-between}.pl-\\[16px\\]{padding-left:16px}.pr-\\[14px\\]{padding-right:14px}.blur{--tw-blur:blur(8px)}.blur,.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.mt-\\[8px\\]{margin-top:8px}.block{display:block}", de = se, d = {
  de: F,
  en: P,
  es: K,
  fr: V,
  it: H,
  ja: R,
  pt: te,
  ru: ne,
  zh: ae,
  ko: M,
  nl: X,
  pl: Z,
  tr: ie
}, pe = class {
  constructor(e) {
    B(this, e), this.optionSelect = S(this, "lhSelect", 7), this.overlayContainerElement = null, this.selectedItem = null, this.focusItemIndex = -1, this.languageCode = "", this.supportedLangs = ["de", "en", "es", "fr", "it", "ja", "ko", "nl", "pl", "pt", "ru", "tr", "zh"], this._options = [], this._inputId = "", this.handleOpen = (t) => {
      t.stopPropagation(), this.disabled || (this.isOpen = !0, this.dropdownItemContainer.scrollTop = 0, setTimeout(() => this.dropdownInput.focus(), 0)), this._options = this.queryOptionItems(), this.applyComponentSize(this._options);
    }, this.handleClose = (t) => {
      t.stopPropagation(), this.isOpen = !1, setTimeout(() => this.dropdownInput.blur(), 0);
    }, this.handleInputFocus = () => {
      this.openFlyoutIfNotOpen();
    }, this.applyComponentSize = (t) => {
      t != null && t.length > 0 && t.forEach((o) => o.size = this.size);
    }, this.removeValue = (t, o = !0) => {
      var n, i;
      t == null || t.stopPropagation(), this.controlled ? this.dropdownInput.value = (i = (n = this.value) === null || n === void 0 ? void 0 : n.toString()) !== null && i !== void 0 ? i : "" : (this.dropdownInput.value = null, this.value = ""), o && this.emitSelectEvent({ selected: void 0 }), this.closeDropdown();
    }, this.openFlyoutIfNotOpen = () => {
      this.isOpen || this.overlayContainerElement.openFlyout().catch(console.warn);
    }, this.toggleClick = () => {
      this.dropdownItemContainer.scrollTop = 0, this.disabled === !1 && setTimeout(() => {
        this.isOpen ? this.dropdownInput.focus() : this.dropdownInput.blur();
      }, 66);
    }, this.selectItem = (t, o) => {
      this.controlled ? this.handleClickControlled() : this.handleClickUncontrolled(t), o && this.emitSelectEvent({ selected: t }), this.closeDropdown();
    }, this.resetFocusIndex = () => {
      this.focusItemIndex = -1;
    }, this.closeOnScroll = !0, this.controlled = !1, this.disabled = !1, this.inputId = "", this.listWidth = "", this.placeholder = "", this.name = "", this.noHorizontalPadding = !1, this.value = void 0, this.size = "big", this.wcag = "", this.width = "100%", this.isOpen = !1, this.i18nState = void 0;
  }
  /**
   * Watch for 'value' changes. Get the label from the first option that matches the value (like the native select element).
   */
  valueWatcher(e) {
    e == null && console.warn("[PatternlibDropdownSubtle] Value is null/undefined. This should not happen."), this.handleValueChange(e);
  }
  /**
   * Public method to focus the input inside the dropdown.
   */
  async setFocus() {
    this.dropdownInput.focus();
  }
  /**
   * Public method to blur the input inside the dropdown.
   */
  async setBlur() {
    this.dropdownInput.blur();
  }
  onOptionSelect(e) {
    e.stopPropagation(), !(e == null || e.detail == null || e.detail.value == null) && (e.detail.selected ? this.selectItem(e.detail, e.detail.propagate) : this.removeValue(e, e.detail.propagate));
  }
  handleKeyPress(e) {
    this.handleKeyUpAndDown(e), this.handleKeyEscape(e), this.handleKeyEnter(e), this.handleKeyTab(e);
  }
  connectedCallback() {
    const e = (t) => {
      const o = j("lang", t);
      this.languageCode = "en", o && this.supportedLangs.includes(o) && (this.languageCode = o), this.i18nState = s.resolveJsonBasedOnLanguage(this.languageCode, d);
    };
    this.observer = new MutationObserver(e), this.observer.observe(document.documentElement, { attributes: !0 });
  }
  componentWillLoad() {
    this.value == null ? (this.value === null && console.warn('[PatternlibDropdownSubtle] Initial value of Prop "value" is null. This should not happen.'), this.value = "") : this.handleValueChange(this.value), this._inputId = this.inputId === "" ? W() : this.inputId, this.wcag === "AAA" && (this.size = "big"), this.languageCode = "en", document.documentElement.lang && this.supportedLangs.includes(document.documentElement.lang) && (this.languageCode = document.documentElement.lang), this.i18nState = s.resolveJsonBasedOnLanguage(this.languageCode, d), this.propagePropsToOptions();
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  emitSelectEvent(e) {
    this.optionSelect.emit(e);
  }
  handleValueChange(e) {
    var t;
    if (this._options = this.queryOptionItems(), this._options != null && this._options.length > 0) {
      this._options.forEach((o) => {
        o.selected = !1;
      });
      for (const o of this._options) {
        const n = o;
        if (n.value == e) {
          this.selectedItem = {
            value: e,
            label: (t = n.label) !== null && t !== void 0 ? t : n.innerText
          }, n.selected = !0;
          return;
        }
      }
    }
    this.selectedItem = null;
  }
  propagePropsToOptions() {
    if (this._options = this.queryOptionItems(), this._options != null && this._options.length > 0)
      for (const e of this._options)
        e.wcag = this.wcag;
  }
  handleKeyEnter(e) {
    var t;
    if (e.key === "Enter") {
      const o = this._options.filter(a), n = o.length === 1 ? o[0] : o[this.focusItemIndex];
      if (n != null) {
        const i = {
          value: n.value,
          label: (t = n.label) !== null && t !== void 0 ? t : n.innerText
        };
        this.selectItem(i, !0);
      } else
        this.removeValue(null, !0);
    }
  }
  handleKeyEscape(e) {
    e.key === "Escape" && (this.selectedItem == null ? this.removeValue(null, !0) : this.closeDropdown());
  }
  handleKeyTab(e) {
    e.key === "Tab" && this.closeDropdown();
  }
  filterUserInput(e) {
    const t = ["Tab", "Escape", "ArrowDown", "ArrowUp"];
    return t.includes(e.key) || e.preventDefault(), t.includes(e.key);
  }
  handleKeyUpAndDown(e) {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      const t = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--component-default-size").split("px")[0]), o = this._options.filter(a);
      this.isOpen || this.openFlyoutIfNotOpen(), e.key === "ArrowDown" && this.focusItemIndex < o.length - 1 && this.focusItemIndex++, e.key === "ArrowUp" && this.focusItemIndex > 0 && this.focusItemIndex--, this.focusItemIndex > 1 && (this.hostElement.shadowRoot.getElementById("dropdown-item-container").scrollTop = (this.focusItemIndex - 2) * t), o.forEach((n, i) => {
        n.focused = this.focusItemIndex === i;
      });
    }
  }
  queryOptionItems() {
    return Array.from(this.hostElement.querySelectorAll("patternlib-option"));
  }
  closeDropdown() {
    this.dropdownItemContainer.scrollTop = 0, this.overlayContainerElement.closeFlyout().catch(console.warn), this.resetFocusOnItem(), this.resetFocusIndex();
  }
  handleClickControlled() {
    var e, t;
    this.dropdownInput.value = (t = (e = this.value) === null || e === void 0 ? void 0 : e.toString()) !== null && t !== void 0 ? t : "";
  }
  handleClickUncontrolled(e) {
    var t;
    this.value = e.value, this.dropdownInput.value = e.label == null || e.label == "" ? (t = e.value) === null || t === void 0 ? void 0 : t.toString() : e.label;
  }
  resetFocusOnItem() {
    this._options.forEach((e) => {
      e.focused = !1;
    });
  }
  render() {
    var e, t, o;
    const n = {
      dropdown: !0
    }, i = {
      "w-full": !0
    }, _ = {
      overlayButton: !this.disabled,
      overlayButtonDisabled: this.disabled,
      overlayButtonFocused: this.isOpen,
      "w-full": !0,
      [this.size]: !0
    }, z = {
      overlayInputWrapper: !0,
      "flex items-center justify-between": !0,
      "pl-[16px] pr-[14px]": !this.noHorizontalPadding
    }, k = {
      overlayArrowIcon: !0
    }, A = {
      overlayInput: !0
    }, C = {
      overlayItemsContainer: !0,
      [this.size]: !0
    }, L = r("div", { key: "21952988a0326d9eda8b858f9fc7a1d1818ce943", class: z }, r("input", {
      key: "d14e4009ee5ae4ed7e074f33b81658bd6cad79d9",
      "aria-expanded": this.isOpen,
      "aria-label": this.i18nState.inputAriaLabel,
      class: A,
      id: this._inputId,
      name: this.name,
      placeholder: this.placeholder,
      readOnly: !0,
      // role="combobox"
      value: (t = (e = this.selectedItem) === null || e === void 0 ? void 0 : e.label) !== null && t !== void 0 ? t : this.value,
      onFocus: this.handleInputFocus,
      onKeyDown: this.filterUserInput,
      ref: (l) => this.dropdownInput = l
    }), r("div", { key: "500039f89e3ef4d1d1fdc978e8a3ca69180043e9", class: k }, r("patternlib-icon", { key: "892ba648345686a765d4b0fd69537e8e8e21d93e", iconName: this.isOpen ? "arrow-up" : "arrow-down", size: "24px" }))), O = r("patternlib-overlay-container", { key: "dce6e850cb56708e5b3fb46c4985ef358436effc", disabled: this.disabled, closeOnScroll: this.closeOnScroll, fit: "element", style: { display: "inline-block" }, useFlyoutGroups: !0, onLhClose: this.handleClose, onLhOpen: this.handleOpen, ref: (l) => this.overlayContainerElement = l }, r("button", { key: "e5408dea897d70d82a952914b3bc8677cd821c9f", "aria-disabled": this.disabled, class: _, slot: "element", style: { width: "100%" }, tabindex: "-1", onClick: this.toggleClick }, L), r("div", { key: "5d81197b431c7a48683715ca49f9f91db1bb6ed4", class: C, id: "dropdown-item-container", style: { width: (o = this.listWidth) !== null && o !== void 0 ? o : "280px" }, slot: "content", ref: (l) => this.dropdownItemContainer = l }, r("slot", { key: "7c45a61bb38f6e874723d612b6f46c719fb97537" })));
    return r(E, { key: "bb1bd76e3b5b6a78c63640a6a37ba58c22db7cd7" }, r("div", { key: "5e4908b5e1c95b3144681e6f57ce5954602c8512", class: n, style: { width: this.width } }, r("patternlib-form-group", { key: "40dcc8cec181ab5f12acd3cc3104fd541639cf5a" }, r("div", { key: "6fc0ff626e7fe715ce0b06e3f68df4a65ab0fad6", class: i, slot: "element" }, O))));
  }
  get hostElement() {
    return D(this);
  }
  static get watchers() {
    return {
      value: ["valueWatcher"]
    };
  }
};
pe.style = de;
export {
  pe as patternlib_dropdownsubtle
};
